import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { FormGroup } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreModal from "../../../app/core/components/CoreModal/CoreModal";
import CoreTextArea from "../../../app/core/components/CoreTextArea/CoreTextArea";
import {
  useDeleteDocumentMutation,
  useEditDocumentMutation,
  useRejectDocumentMutation,
  useValidateDocumentMutation,
} from "../../api/admin/gestisciDocumentiApi";
import { useTranslation } from "react-i18next";
import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr";
import {
  extractYYYYMMDDFromISO,
  generateAnniDiRiferimento,
  toISOString,
} from "../../../utils/functions/date-utils";
import CoreMaxCharacter from "../../../app/core/components/CoreMaxCharacter/CoreMaxCharacter";

const PlainForm = ({
  document = {},
  subCategory,
  closeModal,
  typeButton,
  handleOpenDiscardDialog,
  handleChangeStatusDoc,
}) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    docName: "",
    docDate: "",
    referenceYear: "GENERICO",
    userNotes: "",
    operatorNotes: "",
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [validateDocument, { isLoading: isValidateLoading }] =
    useValidateDocumentMutation();

  const [editDocument, { isLoading: isEditLoading }] =
    useEditDocumentMutation();
  const [rejectDocument, { isLoading: isRejectLoading }] =
    useRejectDocumentMutation();

  const [deleteDocument, { isLoading: isDeleting }] =
    useDeleteDocumentMutation();

  useEffect(() => {
    setFormData({
      docName: document?.name,
      docDate: document?.idDoc?.dataScadenza
        ? extractYYYYMMDDFromISO(document.idDoc.dataScadenza)
        : extractYYYYMMDDFromISO(document.date) || "",
      referenceYear:
        document.referenceYear &&
        document.referenceYear > new Date().getFullYear() - 4
          ? document.referenceYear
          : document.date &&
            new Date(document.date).getFullYear() > new Date().getFullYear() - 4
          ? new Date(document.date).getFullYear() + 1
          : "GENERICO",
      userNotes: document?.notes || "",
      operatorNotes: document?.operatorNotes || "",
    });
  }, [document, document?.id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const confirmDelete = () => {
    deleteDocument(document.id)
      .then((res) => {
        if (res.data.Result === 1) {
          toast.success(t("DocDeleted"));
          setOpenDeleteDialog(false);
          closeModal();
        } else {
          toast.error(t("DocNotDeleted"));
        }
      })
      .catch((err) => toast.error(err));
  };

  const handleDelete = () => {
    handleOpenDeleteDialog();
  };

  const handleOpenDeleteDialog = () => {
    setOpenDeleteDialog(true);
  };
  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleEdit = (e) => {
    e.preventDefault();
    const id = toast.loading(t("Saving..."), {
      type: "info",
    });
    const bodyData = {
      id: document.id,
      CategoryId: subCategory,
      name: formData.docName,
      referenceYear:
        formData.referenceYear === "GENERICO" ? null : formData.referenceYear,
      Notes: document.notes || "",
      OperatorNotes: formData.operatorNotes || "",
    };
    if (formData.docDate) {
      bodyData.date = toISOString(formData.docDate);
    }
    editDocument(bodyData)
      .unwrap()
      .then((data) => {
        if (data.Result !== 1) {
          toast.update(id, {
            render: data.Exception || t("DocNotEdited"),
            type: "error",
            autoClose: 1500,
            isLoading: false,
          });
        }
        toast.update(id, {
          render: t("DocEdited"),
          type: "success",
          autoClose: 1500,
          isLoading: false,
        });
        //nextDocument();
        closeModal();
      })
      .catch(() => {
        toast.update(id, {
          render: t("DocNotEdited"),
          type: "error",
          autoClose: 1500,
          isLoading: false,
        });
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const id = toast.loading(t("Saving..."), {
      type: "info",
    });
    const bodyData = {
      id: document.id,
      CategoryId: subCategory,
      name: formData.docName,
      referenceYear:
        formData.referenceYear === "GENERICO" ? null : formData.referenceYear,
      Notes: document.notes || "",
      OperatorNotes: formData.operatorNotes || "",
    };
    if (formData.docDate) {
      bodyData.date = toISOString(formData.docDate);
    }
    validateDocument(bodyData)
      .unwrap()
      .then((data) => {
        if (data.Result !== 1) {
          toast.update(id, {
            render: data.Exception || t("DocNotValidated"),
            type: "error",
            autoClose: 1500,
            isLoading: false,
          });
          return;
        }
        toast.update(id, {
          render: t("DocValidated"),
          type: "success",
          autoClose: 1500,
          isLoading: false,
        });
        //nextDocument();
        closeModal();
      })
      .catch(() => {
        toast.update(id, {
          render: t("DocNotValidated"),
          type: "error",
          autoClose: 1500,
          isLoading: false,
        });
      });
  };

  return (
    <>
      <div style={{ height: "68vh" }} className=" overflow-scroll">
        <div className="flex flex-col justify-between pt-4 pb-12 items-start gap-4 px-4 mt-6">
          <div className="w-full flex gap-4">
            <CoreInputField
              disabled={document.status === 6}
              className="w-1/2"
              name="docName"
              label={t("DocName")}
              value={formData?.docName}
              onChange={handleInputChange}
            />
            {formData.docDate && (
              <CoreInputField
                disabled={document.status === 6}
                className="w-1/2"
                type="date"
                name="docDate"
                label={
                  document?.idDoc?.dataScadenza ? t("DocExpDate") : t("DocDate")
                }
                value={formData.docDate}
                onChange={handleInputChange}
                InputLabelProps={{ shrink: true }}
              />
            )}

            <div className="pt-6 w-full">
              <CoreSelectObjArr
                disabled={document.status === 6}
                name="referenceYear"
                label={t("ReferenceYear")}
                value={formData.referenceYear}
                items={generateAnniDiRiferimento(
                  new Date().getFullYear() - 4,
                  new Date().getFullYear() + 6,
                  true
                )}
                onChange={handleInputChange}
              />
            </div>
          </div>

          {document.status === 6 ? (
            <div className="py-4 w-full">
              <CoreTextArea
                className="w-full"
                disabled
                rows={5}
                label={t("DiscardNotes")}
                name="notesDiscard"
                value={document.rejectionNotes}
              />
            </div>
          ) : (
            <div className="w-full flex gap-4">
              <FormGroup className="w-1/2 py-5 overflow-auto">
                <CoreTextArea
                  disabled
                  rows={5}
                  label={t("UserNotes")}
                  name="userNotes"
                  value={formData?.userNotes}
                  onChange={handleInputChange}
                />
              </FormGroup>
              <div className="flex w-full items-center">
                <FormGroup className="w-full my-5">
                  <CoreTextArea
                    rows={5}
                    label={t("OperatorNotes")}
                    name="operatorNotes"
                    value={formData.operatorNotes}
                    onChange={handleInputChange}
                    error={formData.operatorNotes?.length > 500}
                  />
                </FormGroup>
                <CoreMaxCharacter
                  maxCharacter={500}
                  text={formData.operatorNotes}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <div
        style={{ borderTop: "1px solid lightgrey" }}
        className="grid grid-cols-2 gap-y-2 justify-items-center pt-2"
      >
        {document.status === 5 && (
          <CoreButton
            onClick={() => handleChangeStatusDoc(document)}
            testo={t("ToValidate")}
            className="btn-round-outline text-white border-yellow-500 bg-yellow-500"
          />
        )}
        {typeButton === t("Save") ? (
          <CoreButton
            className="w-1/2 btn-round"
            disabled={isEditLoading}
            testo={document.status === 6 ? t("Recover") : t("Save")}
            onClick={
              document.status === 6
                ? () => handleChangeStatusDoc(document)
                : handleEdit
            }
          />
        ) : (
          <CoreButton
            onClick={handleSubmit}
            className="btn-round"
            disabled={isValidateLoading}
            disabledclassnames="btn-disabled"
          >
            {typeButton}
          </CoreButton>
        )}
        <CoreButton
          onClick={handleDelete}
          testo={t("Delete")}
          className="w-1/2 btn-round bg-red-700 text-white border-red-700"
        />
        {document.status !== 6 && (
          <CoreButton
            onClick={handleOpenDiscardDialog}
            testo={t("Discard")}
            className="w-1/2 btn-round-outline border-orange-400 text-orange-400"
          />
        )}
      </div>

      <CoreModal
        width={350}
        height={300}
        state={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        component={
          <div className="text-center">
            <div className="text-4xl mb-2">
              <ErrorOutlineIcon
                className="text-red-700"
                sx={{ fontSize: 70 }}
              />
            </div>
            <div className="mb-8">{t("RUSure")}</div>
            <div className="flex justify-between">
              <CoreButton
                className={"btn btn-round-outline"}
                variant="contained"
                testo={t("No")}
                onClick={() => setIsModalOpen(false)}
              />
              <CoreButton
                className={"btn-round"}
                variant="contained"
                testo={t("Discard")}
                disabled={isRejectLoading}
                onClick={() => {
                  rejectDocument({
                    id: document.id,
                    categoryId: document.categoryId,
                  })
                    .then((res) => {
                      if (res.data.Exception) {
                        toast.error(res.data.Exception);
                        closeModal();
                      } else {
                        toast.success(t("DocDiscarded"));
                        closeModal();
                        setIsModalOpen(false);
                      }
                    })
                    .catch((error) => {
                      toast.error(error);
                    });
                }}
              />
            </div>
          </div>
        }
      />
      <CoreDialog
        open={openDeleteDialog}
        title={t("DocDeleting")}
        content={`${t("DocDeletingConfirm")} "${formData?.Name}"?`}
        positiveButton={t("Yes")}
        negativeButton={t("No")}
        handlePositive={confirmDelete}
        closeDialog={handleCloseDeleteDialog}
        disabledButton={isDeleting}
      />
    </>
  );
};

export default PlainForm;
